angular.module('LeasePilot').filter('toFullStateName', function() {
  return function(input) {
    return !!input ? stateAbbreviationToName(input) : '';
  };
});
